<template>
  <div class="single-select" v-click-outside="outsideClick">
    <div
      @click.prevent="toggle"
      class="single-select__input"
      :class="{ 'single-select__input--open': showDropdown }">
      <div class="single-select__text">
        <div
          class="single-select__label"
          :class="{ 'single-select__label--items-selected': modelValue }">
          <img
            v-if="selectedOption?.icon"
            :src="selectedOption.icon"
            class="single-select__list-icon"
            loading="lazy" />
          {{ selectedOption?.name ?? label }}
        </div>
      </div>
    </div>
    <transition name="single-select-dropdown">
      <div v-show="showDropdown" class="single-select__dropdown">
        <!-- Search options based on name. -->
        <div v-if="searchable" class="single-select__search-wrapper">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
            type="text"
            ref="search"
            v-model="optionsSearch"
            id="single-select-search"
            class="single-select__search"
            :placeholder="searchPlaceholder" />
        </div>

        <!-- Options list. -->
        <ul class="single-select__items">
          <li
            v-for="(option, i) in filterOptions"
            :key="`${option.id}-${option.name}-${i}`"
            class="single-select__item">
            <input
              :id="`single-select-${i}`"
              class="single-select__radio visually-hidden"
              type="radio"
              :value="option.id" />
            <label
              :for="`single-select-${i}`"
              class="single-select__list-label"
              :class="{
                'single-select__list-label--disabled':
                  option.id === selectedOption.id,
              }"
              @click.prevent="select(option.id)">
              <img
                v-if="option.icon"
                :src="option.icon"
                class="single-select__list-icon"
                loading="lazy" />
              {{ option.name }}
            </label>
          </li>
          <li
            v-if="filterOptions.length === 0"
            class="single-select__item single-select__item--empty">
            <!-- @todo this naming is too specific for sales contacts AND countries -->
            <p>{{ t.noResultsCountry }}</p>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
// Directives.
import clickOutside from '../../directives/clickOutside';
// Utils.
import translationStrings from '../../translations/translationStrings';

export default {
  directives: {
    clickOutside,
  },
  props: {
    modelValue: {}, // v-model
    label: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    searchable: {
      required: false,
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      optionsSearch: '',
      showDropdown: false,
      t: translationStrings,
    };
  },
  computed: {
    filterOptions() {
      if (this.searchable) {
        return this.options.filter(({ name }) =>
          name.toLowerCase().includes(this.optionsSearch.toLowerCase()),
        );
      }

      return this.options;
    },
    selectedOption() {
      return this.options.find((item) => item.id === this.modelValue) || {};
    },
  },
  methods: {
    select(id) {
      this.$emit('update:modelValue', id);
      this.outsideClick();
    },
    toggle() {
      this.showDropdown = !this.showDropdown;

      // We do this ourselves due to limitations of autofocus attribute.
      this.$nextTick(() => {
        if (this.showDropdown) {
          if (this.$refs.search) {
            this.$refs.search.focus();
          }
        }
      });
    },
    outsideClick() {
      this.showDropdown = false;
      this.optionsSearch = '';
    },
    objectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
  },
};
</script>
